import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import { Form, FormControl } from "react-bootstrap";
import {
  FaBriefcase,
  FaBullhorn,
  FaCartShopping,
  FaCommentDots,
  FaCrown,
  FaGear,
  FaHouse,
  FaLifeRing,
  FaMoneyCheckDollar,
  FaUserGear,
  FaFileContract,
} from "react-icons/fa6";
import profile_icon from "../../../../assets/img/profileIcon.png";
import searchIcon from "../../../../assets/img/searchIcon.svg";

function readProfessionalData() {
  try {
    const raw = localStorage.getItem("professionalData");
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

const Sidebar = ({ onHide }) => {
  const hideSidebar = () => {
    if (typeof onHide === "function") onHide(false);
  };

  const handleViewDetails = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const navigateAndClose = () => {
    handleViewDetails();
    hideSidebar();
  };

  const pro = useMemo(() => readProfessionalData(), []);
  const displayName =
    pro && `${pro.firstName || ""} ${pro.lastName || ""}`.trim()
      ? `${pro.firstName || ""} ${pro.lastName || ""}`.trim()
      : "Professional";

  const initialAvatar =
    pro?.profileImage && String(pro.profileImage).trim() !== ""
      ? pro.profileImage
      : profile_icon;

  const [avatarSrc, setAvatarSrc] = useState(initialAvatar);

  const mainLinks = [
    { to: "/professional/dashboard", label: "Dashboard", Icon: FaHouse },
    { to: "/professional/profile", label: "Profile", Icon: FaUserGear },
    { to: "/professional/jobs", label: "Find Projects", Icon: FaBriefcase },
    { to: "/professional/bids", label: "My Bids", Icon: FaFileContract },
    { to: "/professional/messages", label: "Messages", Icon: FaCommentDots },
    {
      to: "/professional/payment-management",
      label: "Payments",
      Icon: FaMoneyCheckDollar,
    },
    { to: "/professional/campaigns", label: "Promotions", Icon: FaBullhorn },
    { to: "/contacts-us", label: "Help & Support", Icon: FaLifeRing },
    { to: "/professional/settings", label: "Settings", Icon: FaGear },
  ];

  const creditLinks = [
    {
      to: "/professional/buy-credits",
      label: "Buy Credits",
      Icon: FaCartShopping,
    },
    { to: "/professional/pro-plan", label: "Go Pro", Icon: FaCrown },
  ];

  return (
    <div className="pro-slide-sidebar">
      <div className="pro-slide-sidebar__header">
        <div className="pro-slide-sidebar__user">
          <img
            className="pro-slide-sidebar__avatar"
            src={avatarSrc}
            alt=""
            onError={() => setAvatarSrc(profile_icon)}
          />
          <h2 className="pro-slide-sidebar__name">{displayName}</h2>
        </div>
        <button
          type="button"
          className="pro-slide-sidebar__close"
          onClick={hideSidebar}
          aria-label="Close menu"
        >
          <ClearOutlinedIcon fontSize="small" />
        </button>
      </div>

      <nav className="pro-slide-sidebar__nav">
        <Form className="pro-slide-sidebar__search-form">
          <FormControl
            type="search"
            placeholder="Search"
            className="pro-slide-sidebar__search-input"
            aria-label="Search"
          />
          <img
            src={searchIcon}
            alt=""
            className="pro-slide-sidebar__search-icon"
          />
        </Form>

        <ul className="pro-slide-sidebar__list">
          {mainLinks.map(({ to, label, Icon }) => (
            <li key={to}>
              <Link
                to={to}
                className="pro-slide-sidebar__link"
                onClick={navigateAndClose}
              >
                <Icon className="pro-slide-sidebar__icon" aria-hidden />
                <span>{label}</span>
              </Link>
            </li>
          ))}
        </ul>

        <p className="pro-slide-sidebar__section-label">Credits &amp; premium</p>
        <ul className="pro-slide-sidebar__list">
          {creditLinks.map(({ to, label, Icon }) => (
            <li key={to}>
              <Link
                to={to}
                className="pro-slide-sidebar__link"
                onClick={navigateAndClose}
              >
                <Icon className="pro-slide-sidebar__icon" aria-hidden />
                <span>{label}</span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
